import { i18n } from "translate/i18n";

export const errorOnFetchingChallenge = i18n.t(
  "messages.challenge.errorOnFetchingChallenge"
);
export const errorOnFetchingChallenges = i18n.t(
  "messages.challenge.errorOnFetchingChallenges"
);
